export default __webpack_public_path__ + "static/media/news and events (1).e78983e7.jpg";